/**
 * @file Check permissions on whether to allow email/pwd signup onboarding or not.
 */

import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};

const ConsumerEmailAuthAllowed = ({ id = '', children }) => {
  // TODO Turn into a Gallery setting if we're keeping this.
  const ALLOWED_IDS = [
    // DEV env Album or Album Folder ids
    'NwJFx9wx8N3gW5wFZWqEq8J', // Album Folder
    'a6qtcgEJBAcDi3YQm5jw4S', // Album
    'P4xj4uf7hY5fSgMrr6jvfDz', // Album Folder

    // PROD env Album or Album Folder ids
    'NqjKdF51NvTh9nMow5d2C1g', // Hokulea Winter Camp
  ];

  return children(ALLOWED_IDS.includes(id));
};

ConsumerEmailAuthAllowed.propTypes = propTypes;

export default ConsumerEmailAuthAllowed;
